module.exports = __webpack_public_path__ + "static/media/badger-honey.bee802c9.svg";